const baseSearch = require('base/search/search');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find(`.${$(this)[0].className.replace(/ /g, '.')}`);
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
    };

    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
    ].forEach((selector) => {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach((selector) => {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    const $tempDom = $('<div>').append($(response));
    const sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach((option) => {
        $(`option.${option.id}`).val(option.url);
    });
}

function updateUrl(params, isCategory) {
    if (isCategory) {
        params = params.split('cgid').join('refcgid'); // eslint-disable-line
    }

    const currentUrl = new URL(window.location.href);
    const currentParams = new URLSearchParams(currentUrl.search);
    const newParams = new URLSearchParams(params);

    if (!isCategory) {
        newParams.delete('cgid');
    }

    if (!newParams.get('refcgid') && currentParams.get('refcgid')) {
        newParams.set('refcgid', currentParams.get('refcgid'));
    }

    if (newParams.get('sz')) {
        const totalSize = (parseInt(newParams.get('sz')) || 0) + (parseInt(newParams.get('start')) || 0);
        newParams.set('sz', totalSize);
        newParams.set('start', 0);
    }

    let updatedUrl = currentUrl.pathname;

    if (newParams) {
        updatedUrl += `?${newParams.toString()}`;
    }

    window.history.replaceState({}, '', updatedUrl);
}

baseSearch.applyFilter = () => {
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();

            const url = $(this).data('href');
            const isCategory = $(this).hasClass('category-refinement');

            $(this).trigger('search:filter', e);
            $.ajax({
                url,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: url,
                },
                method: 'GET',
                success(response) {
                    parseResults(response);
                    $.spinner().stop();
                    updateUrl(url.split('?')[1], isCategory);
                },
                error() {
                    $.spinner().stop();
                },
            });
        },
    );
};

baseSearch.sort = () => {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);

        var url = this.value;
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success(response) {
                $('.product-grid').empty().html(response);
                $.spinner().stop();
                updateUrl(url.split('?')[1]);
            },
            error() {
                $.spinner().stop();
            },
        });
    });
};

baseSearch.showMore = () => {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        const showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: (response) => {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                updateUrl(showMoreUrl.split('?')[1]);

                try {
                    const yotpoApi = yotpo; //eslint-disable-line

                    if (yotpoApi) {
                        yotpoApi.refreshWidgets();
                    }
                } catch (ex) {
                    console.log(ex); //eslint-disable-line
                }

                $.spinner().stop();
            },
            error: () => {
                $.spinner().stop();
            },
        });
    });
};

module.exports = baseSearch;
